/**
 * Application Configuration
 * 
 * Centralized config for API endpoints and environments.
 * Automatically switches between localhost and production Lambda URL.
 */

const isProduction = window.location.hostname === 'afima.ai' ||
    window.location.hostname === 'www.afima.ai' ||
    window.location.hostname.includes('amplifyapp.com'); // Support Amplify preview URLs

// Lambda Function URL (Production)
const PROD_API_URL = 'https://et3pirtssp34t3j6vrkei2ojj40iqfak.lambda-url.eu-west-1.on.aws';

// Local Python Server (Development) - Pointing to Lambda for Testing
const LOCAL_API_URL = 'https://et3pirtssp34t3j6vrkei2ojj40iqfak.lambda-url.eu-west-1.on.aws';

// Export the determined base URL
export const API_BASE_URL = isProduction ? PROD_API_URL : LOCAL_API_URL;

// Accounting local runner endpoint (runs on localhost:8000 in dev for browser automation)
export const ACCOUNTING_API_BASE_URL = isProduction ? PROD_API_URL : 'http://localhost:8000';

// Dedicated AWS Lambda Function URL for SimplyLoan SMS Scheduler & Campaigns
export const SMS_SCHEDULER_API_URL = 'https://twhyxjsswuej26eh2pumjmisca0bkbos.lambda-url.eu-west-1.on.aws';


console.log(`[Config] Using API URL: ${API_BASE_URL} (Production: ${isProduction})`);
